import { Alert, FormDropDownList, FormMaskedTextBox } from "@mikros/shared-ui";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { useEffect, useRef } from "react";
import { useState } from "react";

import { Button } from "@progress/kendo-react-buttons";
import { useNavigate } from "react-router-dom";
import ApiServices from "../../service/apiService";
import { UserDetails } from "@mikros/library";
import { Dialog } from "@progress/kendo-react-dialogs";
import { FormattedMessage, useIntl } from "react-intl";
import AuthService from "../../service/authService";
import { jwtDecode } from "jwt-decode";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";

export function Personal() {
  const errorInstance = ErrorHandler.getErrorInstance();

  const [personalAdminData, setPersonalAdminData] = useState({} as UserDetails);
  const [showForm, setShowForm] = useState(false);
  const [saveDialog, setSaveDialog] = useState<boolean>(false);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const [sub, setSub] = useState(null);
  const subRef = useRef(null);
  console.log("personal admin user data", personalAdminData);
  const intl = useIntl();
  const toggleSaveDialog = () => {
    setSaveDialog(!saveDialog);
  };
  const accountInstance = Account.getInstance();

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect", subValue);
    }
    fetchSub();
  }, []);

  const navigateToResetPassword = () => {
    console.log("navigate to reset password success");
    navigate(`/reset-password/${subRef.current}`);
  };

  function handleResetPassword() {
    console.log("reset password clicked");
    navigateToResetPassword();

    // TODO: Implement password reset logic
  }
  async function signIn(formData: { [name: string]: any }) {
    console.log("inside signin of personal");
    let data: any = {};
    data["fname"] = formData["fname"];
    data["lname"] = formData["lname"];
    data.email = formData["email"];
    data.phNo = formData["phNo"];
    data.role = formData["role"];
    data.status = formData["status"];
    data.userId = subRef.current;

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      // api
      //   .makeRequest(`${accountInstance.accntId}/customersadmin`, "POST", data)

      api
        .makeRequest(
          `${accountInstance.accntId}/customersadmin/${data.userId}`,
          "PUT",
          data
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          toggleSaveDialog();

          console.log("post response", res);
        });
    }
    console.log("data is", data);
  }
  useEffect(() => {
    let api = ApiServices.getInstance();
    console.log("account instance id value", accountInstance.accntId);
    console.log("sub value", sub);
    if (accountInstance.accntId && sub) {
      api
        .makeRequest(
          `${accountInstance.accntId}/customersadmin/${subRef.current}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("data role in personal settings error", data?.role);
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("data role in personal settings", data?.role);
          const role = data?.role;
          let roleName;

          switch (role) {
            case "tnt_courseScheduler":
              roleName = intl.formatMessage({
                id: "organization.courseScheduler",
              });
              break;
            case "tnt_superAdmin":
              roleName = intl.formatMessage({ id: "organization.superAdmin" });
              break;
            case "tnt_reviewer":
              roleName = intl.formatMessage({ id: "organization.reviewer" });
              break;
            case "tnt_contentCreator":
              roleName = intl.formatMessage({
                id: "organization.contentCreator",
              });
              break;
            case "tnt_admin":
              roleName = intl.formatMessage({ id: "organization.admin" });
              break;
            case "tnt_auditor":
              roleName = intl.formatMessage({ id: "organization.auditor" });
              break;
            default:
              break;
          }
          if (roleName !== undefined) {
            data.role = roleName;
          }
          setPersonalAdminData(data);
          setShowForm(true);
        });
    }
  }, [accountInstance.accntId, sub]);

  const navigate = useNavigate();
  const handleCancelClick = () => {
    navigate("/home");
  };
  const [formKey, setFormKey] = useState(1);
  const nameRegex = new RegExp(/^[a-zA-Z\s.]+$/);
  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const mobileRegexUpdate: RegExp = /^(\+[0-9]{5,20})$/;
  const validators = {
    mobileNumberValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.mobileNumberValidation" })
        : mobileRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "organization.mobileNumberAnotherValidation",
          }),
    mobileNumberUpdateValidator: (value: string) =>
      !value
        ? ""
        : mobileRegexUpdate.test(value)
        ? ""
        : intl.formatMessage({
            id: "organization.mobileNumberAnotherValidation",
          }),
    firstNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.fnameValidation" })
        : nameRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "user.createUser.fnameAnotherValidation" }),
    lastNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.lnameValidation" })
        : nameRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "user.createUser.lnameAnotherValidation" }),
    emailValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.emailValidation" })
        : emailRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.emailAnotherValidation" }),
  };

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);
  return (
    <div>
      <div>
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"/errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
              }}
            />
          </Dialog>
        )}
        {saveDialog && (
          <Dialog className="confirmSuccessDialogue">
            <Alert
              description={`${intl.formatMessage({
                id: "users.createUser.updateUser",
              })}`}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"/successShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgSuccess",
              })}
              backgroundColor={"mk-bright-green"}
              onClick={() => {
                toggleSaveDialog();
                navigate("/home");
              }}
            />
          </Dialog>
        )}
        <div className="text-mk-primary-bright text-xl font-bold">
          <FormattedMessage id="organization.exixtingUserDetails" />
        </div>

        {showForm && (
          <Form
            initialValues={personalAdminData || {}}
            onSubmit={signIn}
            key={formKey}
            render={(formRenderProps) => (
              <FormElement>
                <div className="grid grid-cols-2">
                  <div>
                    <div>
                      <Field
                        name={"fname"}
                        id={"fname"}
                        label={intl.formatMessage({
                          id: "user.createUser.fname",
                        })}
                        component={FormMaskedTextBox}
                        validator={validators.firstNameValidator}
                        className="bg-white w-96"
                        maxLength={50}
                      />
                    </div>
                    <div>
                      <Field
                        name={"email"}
                        id={"email"}
                        label={intl.formatMessage({ id: "personal.email" })}
                        component={FormMaskedTextBox}
                        validator={validators.emailValidator}
                        className="bg-white w-96"
                        maxLength={50}
                      />
                    </div>
                    <div>
                      <Field
                        name={"role"}
                        id={"role"}
                        label={intl.formatMessage({ id: "personal.role" })}
                        component={FormDropDownList}
                        className="bg-white w-96"
                        data={[
                          intl.formatMessage({ id: "personal.superAdmin" }),
                          intl.formatMessage({ id: "personal.admin" }),
                          intl.formatMessage({ id: "personal.contentCreator" }),
                          intl.formatMessage({ id: "personal.approver" }),
                          intl.formatMessage({ id: "personal.user" }),
                          intl.formatMessage({ id: "personal.auditor" }),
                        ]}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <Field
                        name={"lname"}
                        id={"lname"}
                        label={intl.formatMessage({
                          id: "user.createUser.lname",
                        })}
                        component={FormMaskedTextBox}
                        validator={validators.lastNameValidator}
                        className="bg-white w-96"
                        maxLength={50}
                      />
                    </div>
                    <div>
                      <Field
                        name={"phNo"}
                        id={"phNo"}
                        label={intl.formatMessage({
                          id: "personal.mobileNumber",
                        })}
                        maxLength={15}
                        component={FormMaskedTextBox}
                        validator={validators.mobileNumberUpdateValidator}
                        className="bg-white w-96"
                      />
                    </div>
                    <div>
                      <Field
                        name={"status"}
                        id={"status"}
                        label={intl.formatMessage({
                          id: "user.createUser.status",
                        })}
                        component={FormDropDownList}
                        className="bg-white w-40"
                        data={[
                          intl.formatMessage({ id: "personal.enabled" }),
                          intl.formatMessage({ id: "personal.disabled" }),
                        ]}
                      />
                    </div>

                    <div className="flex gap-4 mt-4">
                      <Button
                        type="button"
                        className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                hover:text-black focus:outline-none px-4 py-2"
                        onClick={handleResetPassword}
                      >
                        <FormattedMessage id="personal.resetPassword"></FormattedMessage>
                      </Button>
                      <Button
                        type="submit"
                        className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                hover:text-black focus:outline-none px-4 py-2"
                      >
                        <FormattedMessage id="personal.update"></FormattedMessage>
                      </Button>

                      <Button
                        key={formKey}
                        type="button"
                        onClick={handleCancelClick}
                        className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey

                                hover:text-black focus:outline-none px-4 py-2"
                      >
                        <FormattedMessage id="personal.cancel"></FormattedMessage>
                      </Button>
                    </div>
                  </div>
                </div>
              </FormElement>
            )}
          />
        )}
      </div>
    </div>
  );
}
